import React, { useContext, useEffect, useRef } from "react";
import VideoCard from "../VideoCard";
import { MeetingContext } from "@/pages/Meeting";
import style from "./style.module.scss";
// import Whiteboard from "../../Whiteboard";

const SpeakerLayout: React.FunctionComponent = () => {
  // const { participants, board, service } = useContext(MeetingContext);
  const { participants, service } = useContext(MeetingContext);
  // 使用 useRef 来存储 Participants 的前一个状态
  const prevParticipantsRef = useRef(participants);

  const mainParticipant =
    participants.find((d) => d.share) ||
    participants.find((d) => d.active) ||
    participants.find((d) => d.pinned) ||
    participants[1] ||
    participants[0];

    //如果是演讲者，则显示演讲者的小图，无论他有没有视频
  const subParticipant = participants.find((d) => {
    if(mainParticipant.peerId.startsWith("share_")){
      return d.peerId == mainParticipant.peerId.split("share_")[1]
    }
    return false;
  }) ||
  participants[0];

  useEffect(() => {
    // 检查 Participants 数组长度是否变化
    const isLengthChanged = prevParticipantsRef.current.length !== participants.length;
    // 检查 Participants 数组中 video 字段是否变化
    const isVideoChanged = prevParticipantsRef.current.some((participant, index) => {
      return participant.pinned !== participants[index]?.pinned;
    });
    if (isLengthChanged || isVideoChanged) {
      console.log('Participants length or video states changed');
      // 处理 Participants 变化的逻辑
      (async function initFunction() {
        console.log(`[SpeakerLayout] useEffect participants length=${participants.length}`);
        await init();
      })();

      // 更新 prevParticipantsRef 为当前 Participants
      prevParticipantsRef.current = participants;
    }
    
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [participants.length]);

  const init = async () => {
    if (window.roomClient) {
  

      for (let i = 1; i < participants.length; i++) {
        //屏幕共享流不处理
        if (participants[i].share) {
          continue;
        }
        //有可能mainParticipant是share_开头的，要看看是谁共享的，就让谁占用subParticipant的位置
        if (mainParticipant.peerId.includes(participants[i].peerId)) {
          if (participants[i].videoTrack) {
            continue;
          }
          await service.setParticipantInActivePage(participants[i].peerId, true);
          continue;
        }
        await service.setParticipantInActivePage(participants[i].peerId, false);
      }
    }
  };

  // const operateWhiteBoardShow = (f: boolean) => {
  //   service.sendCustomCmdMsg({
  //     cmdId: f ? 20 : 29,
  //     data: {},
  //   });
  //   board.setBoardShow(f);
  // };

  return (
    <>
      <div className={style.main}>
        <VideoCard participant={mainParticipant} cover showTool={false} />
        {/* {board.boardShow && (
          <div className={style.wb}>
            <Whiteboard leave={() => operateWhiteBoardShow(false)} />
          </div>
        )} */}
      </div>
      <div className={style.sub}>
        <VideoCard participant={subParticipant} />
      </div>
    </>
  );
};
export default SpeakerLayout;
